import {Injectable} from '@angular/core';
import {ToastController} from '@ionic/angular';

@Injectable({
  providedIn: 'root'
})
export class ToastService {

  constructor(private toastCtrl: ToastController) { }

  async presentErrorMessage(message: string, duration: number = 4000) {
    const toast = await this.toastCtrl.create({
      cssClass: 'toast-error',
      color: 'danger',
      position: 'top',
      message,
      duration
    });
    toast.present();
  }

  async presentSuccessMessage(message: string, duration: number = 4000) {
    const toast = await this.toastCtrl.create({
      cssClass: 'toast-success',
      color: 'success',
      position: 'top',
      message,
      duration
    });
    toast.present();
  }
}
